import { render, staticRenderFns } from "./LikePost.vue?vue&type=template&id=612faadb"
import script from "./LikePost.vue?vue&type=script&lang=js"
export * from "./LikePost.vue?vue&type=script&lang=js"
import style0 from "./LikePost.vue?vue&type=style&index=0&id=612faadb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports